import { render } from "./model-input.html?vue&type=template&id=3ba61096&scoped=true&ts=true"
import script from "./model-input.ts?vue&type=script&lang=ts"
export * from "./model-input.ts?vue&type=script&lang=ts"

import "./model-input.scss?vue&type=style&index=0&id=3ba61096&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba61096"]])

export default __exports__